var map = {
	"./GlassEmoji": 7,
	"./GlassEmoji.js": 7,
	"./GlassEmoji.svg": 66,
	"./Myresume.pdf": 67,
	"./beez.png": 68,
	"./bookify.JPG": 69,
	"./cabmate.JPG": 70,
	"./codepen.svg": 14,
	"./facebook.svg": 15,
	"./github.svg": 16,
	"./homesecurity.JPG": 71,
	"./linkedin.svg": 17,
	"./mail.svg": 18,
	"./medium.svg": 19,
	"./netflix.JPG": 12,
	"./newsapp.JPG": 72,
	"./package_updater.png": 73,
	"./package_updates_ss.png": 74,
	"./portfolio.JPG": 75,
	"./quora.svg": 20,
	"./swades.JPG": 76,
	"./twitter.svg": 21,
	"./vconnect.jpg": 77
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 65
// module chunks = 0